import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import template from './rooms.vue';
import apiService from '@/services/api.service';
import { Company, Room, ModalComponents } from '@/definitions';
import { Action } from '@/store';
import { LocalUser } from '@/store/store.definitions';
import { Tab } from '..';

interface Open {
  index: number;
  open: boolean;
};

@Component({
  mixins: [template],
})
export default class SettingsRooms extends Vue {
  @Prop() model!: Room[];
  @Prop() tab!: Tab;
  open: Open[] | null = null;
  showDelete: any = {};

  @Watch('rooms')
  updateOpenArray(newValue: Room[]) {
    if (newValue) {
      this.model.splice(0, this.model.length, ...newValue);
      if (!this.open) this.open = [];
      if (this.open && this.open.length) {
        this.model.forEach((room, i) => {
          const r = this.open?.find(o => o.index === i);
          if (!r) {
            this.open?.push({ index: i as number, open: false });
          }
        });
      } else if (this.open) {
        this.model.forEach((room: Room, i: number) => {
          this.open?.push({ index: i as number, open: i === 0 ? true : false });
        });
      }

      this.showDelete = {};
      this.model.forEach((room, ri) => {
        this.showDelete[`${ri}`] = false;
        room.seats.forEach((seat, si) => {
          this.showDelete[`${ri}-${si}`] = false;
        });
      });

      this.$emit("applyChange", this.tab, this.model);
    }
  }

  mounted() {
    this.updateOpenArray(this.model);
  }

  get rooms(): Room[] {
    return this.$Store.state.company.rooms;
  }

  get company(): Company {
    return this.$Store.state.company.company;
  }

  get user(): LocalUser {
    return this.$Store.state.user;
  }

  showDeleteButton(key: string) {
    this.showDelete[key] = true;
    this.showDelete = { ...this.showDelete };
  }

  isOpen(room: Room): boolean {
    let open = null;
    if (this.open) {
      open = (this.open as Open[]).find(o => o.index === this.model.indexOf(room));
    }
    return open?.open || false;
  }

  toggleRoom(room: Room) {
    if (this.open) {
      const i = (this.open as Open[]).findIndex(o => o.index === this.model.indexOf(room));
      this.open[i].open = !this.open[i].open;
    }
  }

  addRoom() {
    const modalData = {
      component: ModalComponents.ADD_ROOM,
      props: {
        disallowed: this.getDisallowedRoomNames(-1)
      }
    };
    this.$Store.dispatch(Action.SHOW_MODAL, modalData);
  }

  addSeat(roomIndex: number) {
    const modalData = {
      component: ModalComponents.ADD_SEAT,
      props: {
        roomIndex
      }
    };
    this.$Store.dispatch(Action.SHOW_MODAL, modalData);
  }

  async saveChanges() {
    try {
      this.open = [];
      await apiService.saveCompanyRooms(this.company._id, [...this.model]);
      this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.settings.save_success', type: 'success' });
      this.$emit("changesSaved", this.tab);
    } catch (e) {
      this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.settings.save_error', type: 'danger' });
    }
  }

  getDisallowedRoomNames(i: number) {
    const rooms = [...this.model];
    if (i !== -1) rooms.splice(i, 1);
    return rooms.map(r => r.friendlyName);
  }

  editRoom(i: number) {
    const modalData = {
      component: ModalComponents.ADD_ROOM,
      props: {
        roomIndex: i,
        disallowed: this.getDisallowedRoomNames(i)
      }
    };
    this.$Store.dispatch(Action.SHOW_MODAL, modalData)
  }

  removeRoom(i: number) {
    const rooms = [...this.model];
    rooms.splice(i, 1);
    this.$Store.dispatch(Action.UPDATE_COMPANY, { company: this.company, rooms })
  }

  editSeat(roomIndex: number, seatIndex: number) {
    const modalData = {
      component: ModalComponents.ADD_SEAT,
      props: {
        roomIndex,
        seatIndex,
        seat: { ...this.model[roomIndex].seats[seatIndex] }
      }
    };
    this.$Store.dispatch(Action.SHOW_MODAL, modalData);
  }

  removeSeat(room: Room, i: number) {
    room.seats.splice(i, 1);
    const rooms = [...this.model];
    this.$Store.dispatch(Action.UPDATE_COMPANY, { company: this.company, rooms });
  }
}